import { render } from "./app-image.vue?vue&type=template&id=1d2e81c0&scoped=true"
import script from "./app-image.vue?vue&type=script&lang=js"
export * from "./app-image.vue?vue&type=script&lang=js"

import "./app-image.vue?vue&type=style&index=0&id=1d2e81c0&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2e81c0"]])

export default __exports__